import { connect } from 'react-redux'

import { setPageInfo } from '../actions/pageInfo'

const mapStateToProps = state => ({
  pageInfo: state.pageInfo
})

const mapDispatchToProps = dispatch => ({
  setPageInfo: pageInfo => dispatch(setPageInfo(pageInfo))
})

export default connect(mapStateToProps, mapDispatchToProps)



// WEBPACK FOOTER //
// ./src/hocs/withPageInfo.js